export default __webpack_public_path__ + "static/media/AnastasiaLovelace.b761d9e5.png";